import axios from 'axios';

//****************************CHECKLISTS ENDPOINTS(GET):*********************************************\\
export const getChecklists = async (
	checklistType,
	customerID = null,
	addressID = null,
) => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/checklist/GetChecklists?customerID=${customerID}&addressID=${addressID}&checklistType=${checklistType}`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		});
		return data || [];
	} catch (error) {
		console.log('ERROR GET CONTACT DATA :>> ', error);
		throw error;
	}
};
export const getChecklist = async (checklistID) => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/checklist/GetChecklist?checklistID=${checklistID}`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		});
		return data || [];
	} catch (error) {
		console.log('ERROR GET CONTACT DATA :>> ', error);
		throw error;
	}
};

//*********************************************CHECKLISTS ENDPOINTS(POST):*********************************************\\
export const saveChecklist = async (checklist) => {
	try {
		const { data } = await axios({
			method: 'POST',
			url: `/api2.0/Checklist/SaveChecklist`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
			data: checklist,
		});
		return data;
	} catch (error) {
		console.log('ERROR GET CONTACT DATA :>> ', error);
		throw error;
	}
};

export const copyChecklists = async (checklistIDs) => {
	try {
		const { data } = await axios({
			method: 'POST',
			url: `/api2.0/Checklist/CopyChecklists`,
			data: checklistIDs,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		});
		return data; //CREATED CHECKLIST_ID IS RETURNED HERE
	} catch (error) {
		console.log('ERROR COPYING CHECKLISTS:>> ', error);
		throw error;
	}
};
//********************************************* CHECKLISTS ENDPOINTS(DELETE) *********************************************\\
export const deleteChecklists = async (checklistIDs) => {
	try {
		const { data } = await axios({
			method: 'POST',
			url: `/api2.0/Checklist/DeleteChecklists`,
			data: checklistIDs,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		});

		return data;
	} catch (error) {
		console.log('ERROR GET CONTACT DATA :>> ', error);
		throw error;
	}
};
//********************************************* CHECKPOINT ENDPOINTS(GET) *********************************************\\
export const getCheckpoints = async (checklistID) => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/Checklist/GetCheckpoints?checklistID=${checklistID}`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		});
		return data || [];
	} catch (error) {
		console.error('Error in fetching checkpoints: ', error);
		throw error;
	}
};

export const getCheckpointResponseTypes = async () => {
	try {
		const { data } = await axios({
			method: 'GET',
			url: `/api2.0/Checklist/GetCheckpointResponseTypes`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		});
		return data;
	} catch (error) {
		console.log('ERROR getCheckpointResponseTypes :>> ', error);
		return [];
	}
};

//********************************************* CHECKPOINT ENDPOINTS(POST) *********************************************\\
export const saveCheckpoints = async (checkpoints, checklistID) => {
	try {
		const { data } = await axios({
			method: 'POST',
			url: `/api2.0/Checklist/SaveCheckpoints?checklistID=${checklistID}`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
			data: checkpoints,
		});
		return data;
	} catch (error) {
		console.log('ERROR GET CONTACT DATA :>> ', error);
	}
};

//==========================TEST & OTHER=====================================//
export const TestMethod = async () => {
	const data = { Contact_id: 10 };
	console.log('data :>> ', data);
	try {
		const { returned_data } = await axios({
			method: 'POST',
			url: `/api2.0/checklist/TestPostMethod`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
			data: { data },
		});

		console.log('returned_data :>> ', returned_data);

		return returned_data;
	} catch (error) {
		console.log('ERROR GET CONTACT DATA :>> ', error);
	}
};
